<template>
    <section>
        <div class="row">
            <div class="col-12">
                <store-service-list></store-service-list>
            </div>
        </div>
    </section>
</template>

<script>
import StoreServiceList from '@/components/storeService/List';

export default {
    components: {
        StoreServiceList
    }
}
</script>